import { Directive, Input, Renderer2, TemplateRef, ViewContainerRef, inject } from '@angular/core';
import { LoaderComponent } from '@shared/components/loader/loader.component';

@Directive({
  selector: '[recrewtLoader]',
  standalone: false,
})
export class LoaderDirective {
  private templateRef = inject<TemplateRef<any>>(TemplateRef);
  private viewContainer = inject(ViewContainerRef);
  private renderer2 = inject(Renderer2);

  @Input() set recrewtLoader(loading: boolean | null) {
    if (loading) {
      this.viewContainer.clear();
      const ref = this.viewContainer.createComponent(LoaderComponent);
      this.renderer2.addClass(ref.location.nativeElement, 'width-match-parent');
    } else {
      this.viewContainer.clear();
      this.viewContainer.createEmbeddedView(this.templateRef);
    }
  }
}
